import { Card } from "@/components/shadcn/card";
import { ReactNode, RefObject } from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  children: ReactNode;
  elementRef: RefObject<HTMLDivElement>;
  rendered: boolean;
};

const GraphLoadingWrapper = ({ children, elementRef, rendered }: Props) => (
  <Card
    className={twMerge(
      "relative flex w-full flex-1 flex-col overflow-hidden p-0",
      !rendered && "aspect-(--aspect)",
    )}
    ref={elementRef}
  >
    {children}
  </Card>
);

export default GraphLoadingWrapper;
